export default __webpack_public_path__ + "static/LittlePrinceTame-ef70b9fa019cced14985dd72e2dc5c5f.png";